import axios from '~/helpers/orchestration/axiosWithAuthHandling';
import { orchestration } from '~/config/public';
import { AuctionSitemap } from '~/App/shared/interfaces/Auction';

export const getBasicAuctions = async (state: 'open' | 'closed') => {
  if (state === 'closed') {
    return (
      await axios.get<AuctionSitemap[]>(
        `${orchestration.url}/auction/auctions/basic-information/closed`,
        {
          responseType: 'json'
        }
      )
    ).data;
  }

  return (
    await axios.get<AuctionSitemap[]>(
      `${orchestration.url}/auction/auctions/basic-information/open`,
      {
        responseType: 'json'
      }
    )
  ).data;
};
